import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import { getSettings } from './config';
import { logInfo } from './utils/logging';

const settings = getSettings();

Sentry.init({
    dsn: settings.SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
});

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    overflowX: 'hidden',
                },
            },
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Sentry.ErrorBoundary fallback={"An error has occurred"}>
                <App />
            </Sentry.ErrorBoundary>
        </ThemeProvider>
    </React.StrictMode>
);
